import { BsFiletypeHtml, BsFiletypeCss, BsBootstrap } from "react-icons/bs";
import { FaNodeJs } from "react-icons/fa";
import { TbBrandNextjs } from "react-icons/tb";
import {
  SiJavascript,
  SiMui,
  SiReact,
  SiTailwindcss,
  SiFigma,
  SiAdobexd,
  SiAdobephotoshop,
  SiMongodb,
  SiMysql,
  SiTypescript,
  SiGithub,
  SiWordpress,
  SiFirebase,
  SiDocker,
  SiExpress,
  SiNginx,
  SiAngular,
} from "react-icons/si";
export const TechstackList = [
  {
    _id: 1,
    name: "HTML",
    icon: BsFiletypeHtml,
  },
  {
    _id: 2,
    name: "CSS / SCSS",
    icon: BsFiletypeCss,
  },
  {
    _id: 3,
    name: "Bootstrap",
    icon: BsBootstrap,
  },
  {
    _id: 4,
    name: "Javascript",
    icon: SiJavascript,
  },
  {
    _id: 5,
    name: "TypeScript",
    icon: SiTypescript,
  },
  {
    _id: 6,
    name: "Angular",
    icon: SiAngular,
  },
  {
    _id: 7,
    name: "React JS",
    icon: SiReact,
  },
  {
    _id: 8,
    name: "Nextjs",
    icon: TbBrandNextjs,
  },
  {
    _id: 9,
    name: "React MUI",
    icon: SiMui,
  },
  {
    _id: 10,
    name: "Tailwind ",
    icon: SiTailwindcss,
  },
  {
    _id: 11,
    name: "Figma ",
    icon: SiFigma,
  },
  {
    _id: 12,
    name: "Adobe XD ",
    icon: SiAdobexd,
  },
  {
    _id: 13,
    name: "Photoshop ",
    icon: SiAdobephotoshop,
  },
  {
    _id: 14,
    name: "React Native ",
    icon: SiReact,
  },
  {
    _id: 15,
    name: "Node JS ",
    icon: FaNodeJs,
  },
  {
    _id: 16,
    name: "Express JS ",
    icon: SiExpress,
  },
  {
    _id: 17,
    name: "Wordpress ",
    icon: SiWordpress,
  },
  {
    _id: 18,
    name: "Mongodb ",
    icon: SiMongodb,
  },
  {
    _id: 19,
    name: "SQL ",
    icon: SiMysql,
  },
  {
    _id: 20,
    name: "Firebase ",
    icon: SiFirebase,
  },
  {
    _id: 21,
    name: "Git / Github ",
    icon: SiGithub,
  },
  {
    _id: 22,
    name: "Docker ",
    icon: SiDocker,
  },
  {
    _id: 23,
    name: "Nginx ",
    icon: SiNginx,
  },
];